/**
 * Tracks an event in Segment, if the window.analytics object is defined.
 * window.analytics is defined by the Segment snippet the server inlines into the page
 * (see buildSegmentSnippet in utils/segment-snippet.utils.js)
 * @param event - The event to track
 * @param properties - The properties to track
 */
const trackEvent = (event: string, properties?: Record<string, unknown>) => {
  if (typeof window === "undefined" || !window.analytics) {
    return;
  }

  window.analytics.track(event, properties);
};

const identifyEvent = (ssoID: string, properties?: Record<string, unknown>) => {
  if (typeof window === "undefined" || !window.analytics) {
    return;
  }

  window.analytics.identify(ssoID, properties);
};

const aliasEvent = (ssoID: string) => {
  if (typeof window === "undefined" || !window.analytics) {
    return;
  }

  window.analytics.alias(ssoID);
};

export { aliasEvent, identifyEvent, trackEvent };
